import { get } from '@/helpers/http'
import { APINotificationCount } from '@/types/api/notificationCount'

export async function fetchNotificationCount(siteId: number): Promise<APINotificationCount> {
  return (await get(`/alerts/sites/${siteId}/notifications/count/`)) as Promise<APINotificationCount>
}
